import Axios from 'axios'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { defineMessages, FormattedMessage } from 'react-intl'

import frontIcon from '../../../../client/assets/img/id-card-front.svg'

const messages = defineMessages({
  verify_form_title:{
    id: 'verify_form.title',
    defineMessage: 'Загрузите или перетащите изображения. Документ должен помещаться в кадр целиком, информация должна быть читабельной.'
  },
  verify_form_available_files: {
    id: 'verify_form.available_files',
    defineMessage: 'Разрешенные файлы: image/jpeg, image/png.'
  },
  verify_form_max_file_size: {
    id: 'verify_form.max_file_size',
    defineMessage: 'Размер не более: 20.00 мб.'
  },
  verify_form_front_side: {
    id: 'verify_form.document_front_side',
    defineMessage: 'Лицевая сторона документа'
  },
  verify_form_back_side: {
    id: 'verify_form.document_back_side',
    defineMessage: 'Оборотная сторона документа'
  },
  verify_form_selfie: {
    id: 'verify_form.selfie_with_document',
    defineMessage: 'Селфи с документом'
  },
  verify_form_send: {
    id: 'verify_form.submit',
    defineMessage: 'Отправить'
  },
  loading: {
    id: 'loading',
    defineMessage: 'Загрузка...'
  }
})

class VerifyForm extends Component {
  state = {
    front: '',
    back: '',
    face: '',
    sending: false,
  }

  handleSubmit = () => {
    const formData = new FormData()
    formData.append('id', this.props.accountNumber)
    formData.append('front', this.state.front)
    formData.append('back', this.state.back)
    formData.append('face', this.state.face)

    this.setState({ sending: true })

    Axios({
      url: '/verify',
      method: 'POST',
      data: formData,
    })
      .then((res) => {
        if (res.status === 200) {
          alert('Заявка отправлена!')
          window.location.assign('/')
        }
      })
      .catch(() => {
        alert('Ошибка, попробуйте позже!')
      })
      .finally(() => {
        this.setState({ sending: false })
      })
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
  }

  render() {
    const { accountNumber } = this.props
    const { front, back, face, sending } = this.state

    if (!accountNumber) {
      return null
    }

    return (
      <div className="verify_form">
        <p style={{
          lineHeight: '1.5',
        }}>
          <FormattedMessage {...messages.verify_form_title} />
          <br />
          <FormattedMessage {...messages.verify_form_available_files} />
          <br />
          <FormattedMessage {...messages.verify_form_max_file_size} />
        </p>
        <br />
        <label>
          {front && <img className="preview" src={URL.createObjectURL(front)} alt="" />}
          <img src={frontIcon} alt="" height={40} />
          <p>
            <FormattedMessage {...messages.verify_form_front_side} />
          </p>
          <input type="file" name="front" onChange={this.handleChangeImage} accept="image/png, image/jpeg" />
        </label>
        <label>
          {back && <img className="preview" src={URL.createObjectURL(back)} alt="" />}
          <img className="icon" src={frontIcon} alt="" height={40} />
          <p>
            <FormattedMessage {...messages.verify_form_back_side} />
          </p>
          <input type="file" name="back" onChange={this.handleChangeImage} accept="image/png, image/jpeg" />
        </label>
        <label>
          {face && <img className="preview" src={URL.createObjectURL(face)} alt="" />}
          <img src={frontIcon} alt="" height={40} />
          <p>
            <FormattedMessage {...messages.verify_form_selfie} />
          </p>
          <input type="file" name="face" onChange={this.handleChangeImage} accept="image/png, image/jpeg" />
        </label>

        <div className="controls">
          {sending ? (
            <button disabled={true}>
              <FormattedMessage {...messages.loading} />
            </button>
          ) : (
            <button onClick={this.handleSubmit} disabled={!(front && back && face)}>
              <FormattedMessage {...messages.verify_form_send} />
            </button>
          )}
        </div>
      </div>
    )
  }
}

export default connect((s) => {
  const user = s.auth.get('user')

  return {
    accountNumber: user ? user.get('accountNum') : null,
  }
})(VerifyForm)



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/IdentifyPage.jsx